import axios from 'axios';

window.API_BASE_URL = process.env.VUE_APP_API_BASE_URL || '';
window.API_HOST_URL = window.API_BASE_URL.replace('/api', '')
// Replace "__HOST__" with current browser host at runtime (docker-proxy).
const baseURL = window.API_BASE_URL.includes('__HOST__')
  ? window.API_BASE_URL.replace('__HOST__', window.location.host)
  : window.API_BASE_URL;

// Create a new axios instance
const axiosInstance = axios.create({
  // baseURL: 'http://127.0.0.1:8000/api', 
  baseURL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add request interceptor to attach the token to the request
axiosInstance.interceptors.request.use(
  (config) => {
    const authToken = localStorage.getItem('auth_token');
    const storeId = localStorage.getItem('store_id');

    if (authToken) {
      // Set the Authorization header with the Token prefix
      config.headers['Authorization'] = `Token ${authToken}`;
    }

    if (storeId) {
      config.headers["X-Store-ID"] = storeId;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add response interceptor to handle errors globally (optional)
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      // Handle unauthorized (e.g., logout user)
      localStorage.removeItem('auth_token');
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
